import { DateTime } from "luxon";

import type { WaterlyAppStateCreator } from "./waterlyAppStateCreator.type";

type DevEnvBannerState = {
  bannerDismissedTime: string;
};

type DevEnvBannerActions = {
  showDevBanner: () => boolean;
  closeDevBanner: () => void;
};

const initialState: DevEnvBannerState = {
  bannerDismissedTime: DateTime.now().minus({ day: 1 }).toISO(),
};

export const createDevEnvBannerSlice: WaterlyAppStateCreator<DevEnvBannerActions, DevEnvBannerState> = (
  set,
  get,
) => ({
  ...initialState,
  showDevBanner: () => {
    const { bannerDismissedTime } = get();
    return !DateTime.now().hasSame(DateTime.fromISO(bannerDismissedTime), "day");
  },
  closeDevBanner: () => {
    set({ bannerDismissedTime: DateTime.now().toISO() });
  },
});
